import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import StatusBadge from './components/StatusBadge';
import ChangeStatusModal from './components/ChangeStatusModal';
import { loadStatuses, usableStatuses } from './utils/statuses';
const statusOf = discussion => discussion.nhStatus?.() ?? null;
export default function addStatus() {
  // Always include the status relationship in discussion lists.
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    params.include.push('nhStatus');
  });

  // ---- composer: status picker in the header ----
  extend('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    loadStatuses().then(() => m.redraw());
  });
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const fields = this.composer.fields;
    const statuses = usableStatuses();
    const options = {
      '': String(app.translator.trans('neverhack-forum-nodes.forum.status.composer_placeholder'))
    };
    statuses.forEach(s => options[String(s.id())] = s.name());
    const current = fields.nhStatus || null;
    items.add('nhStatus', m("span", {
      className: "DiscussionComposer-nhStatus"
    }, m(StatusBadge, {
      status: current
    }), m(Select, {
      className: "DiscussionComposer-nhStatusSelect",
      options: options,
      value: current ? String(current.id()) : '',
      onchange: id => {
        fields.nhStatus = id ? app.store.getById('nh-statuses', id) : null;
      }
    })), 5);
  });
  extend('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    const status = this.composer.fields.nhStatus || null;
    if (status) {
      data.relationships = data.relationships || {};
      data.relationships.nhStatus = status;
    }
  });

  // ---- discussion list: badge before the title ----
  extend(DiscussionListItem.prototype, 'mainView', function (vdom) {
    const status = statusOf(this.attrs.discussion);
    if (!status || !vdom) return;
    const children = Array.isArray(vdom.children) ? vdom.children : [];
    const h2 = children.find(c => c && c.tag === 'h2');
    if (!h2) return;
    const title = Array.isArray(h2.children) ? h2.children : [h2.children];
    h2.children = [m(StatusBadge, {
      status: status,
      className: "DiscussionListItem-nhStatus"
    }), ...title];
  });

  // ---- discussion hero: badge next to the title ----
  extend(DiscussionHero.prototype, 'items', function (items) {
    const status = statusOf(this.attrs.discussion);
    if (status) {
      items.add('nhStatus', m(StatusBadge, {
        status: status,
        className: "DiscussionHero-nhStatus"
      }), 5);
    }
  });

  // ---- controls: change status later ----
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.attribute('canNhStatus')) {
      items.add('nhStatus', m(Button, {
        icon: "fas fa-tag",
        onclick: () => app.modal.show(ChangeStatusModal, {
          discussion
        })
      }, app.translator.trans('neverhack-forum-nodes.forum.status.change_button')), -5);
    }
  });
}